/* eslint-disable no-bitwise */
export default function() {
  const timestamp = ((Date.now() / 1000) | 0).toString(16);
  return (
    timestamp +
    'xxxxxxxxxxxxxxxx'
      .replace(/[x]/g, () => {
        return ((Math.random() * 16) | 0).toString(16);
      })
      .toLowerCase()
  );
}



// WEBPACK FOOTER //
// ./src/utils/createMongoId.js